import * as React from "react";
import { IDataEntity } from "../models";
import { PerformanceTable } from '../Rankia/Components/PerformanceTable/PerformanceTable';
import * as request from "superagent";
import * as rankiaData from "../data/rankia.data";
import { appConfig } from "../../config";
let translations = require("../data/translations.json");
let sector_translations = require("../data/translations_sector.json");
let rankiaIdentifiers = require("../data/identifiers.json");
let env = appConfig.envDetails[process.env["NODE_ENV"]];


interface InState {
    funds?: any;
    identifiers?: any;
    translationGroup?: any;
}

interface InProps<T> {
    children?: React.ReactNode;
    key?: React.Key;
    ref?: React.Ref<T>;
    appParams?: {[key: string]: string};
}

export class RankiaPerformanceContainer extends React.Component<InProps<{}>, InState>{

    constructor() {
        super();
        this.state = {
            funds: {},
            identifiers: {},
            translationGroup: {}
        };
    }

    componentWillMount() {
        let productRange = "OEIC"; // Default product range
        if(this.props && this.props.appParams && this.props.appParams.productrange && this.props.appParams.productrange.trim().length > 0){
            productRange = this.props.appParams.productrange;
        }

        let rankiaIds = this.getRankiaData(productRange);

        let translationsLocal = this.getTranslations(rankiaIds["translations"]);
        translationsLocal.sector = sector_translations;
        this.setState({ translationGroup: translationsLocal });

        this.defineIdentifers(rankiaIds["ids"]);
        let context = this;

        //These search props get completely mutated?! 14 go in 12 come out?
        this.getFundPressData(false, "FUND", rankiaData.RANKIA_FUND_SEARCH_PROPS).then((res) => {
            let fundObject = context.defineFilteredList(res, true, false);
            context.setState({ funds: fundObject });
        });

        this.getFundPressData(true, "CLSS", rankiaData.RANKIA_SHARECLASS_SEARCH_PROPS).then((res) => {
            let benchMarkIds = this.getBenchMarkIdentifiers(res);
            return context.defineFilteredList(res, false, benchMarkIds);
        }).then((idn) => {
            if (this.checkIdentifiersPresent(idn, 'comparative_index_sec_id') || this.checkIdentifiersPresent(idn, 'peer_group_sec_id')) {
                let searchList = this.getBenchmarkSearchList(idn);
                context.getFundPressData(true, "BMRK", searchList).then((res: IDataEntity[]) => {
                    idn = context.buildBenchmarkList(res.filter(bm => bm.statistics.length > 0), searchList, idn);
                    context.setState({ identifiers: idn });
                });
            }
            else {
                context.setState({ identifiers: idn });
            }
        });
    }

    render() {
        return (
            <PerformanceTable funds={this.state} sorting={this.sortList} />
        );
    }

    getFundPressData(stats, type, search) {
        let statistics = {};
        if (stats) {
            statistics = { "statistics": {} };
        }

        return new Promise((resolve, reject) => {
            request
                .post(`${env.fundPressHost}/fund/searchentity`)
                .send({
                    "type": type,
                    "clientCode": [""],
                    "search": search,
                    "sort": { "key": "asset_class", "direction": "ASC" },
                    "include": statistics,
                    "applyFormats": true,
                    "culture": "en-GB",
                    "limit": 150,
                    "start": 0
                })
                .set('Content-Type', 'application/json')
                .set('X-KSYS-TOKEN', env.token)
                .end((err, res) => {
                    err ? reject(err) : resolve(res.body.values);
                });
        });
    }

    defineFilteredList(list, fund, benchIds) {
        let urlsRankia = rankiaData.RANKIA_URLS,
            isins = rankiaData.RANKIA_SHARECLASS_SEARCH_PROPS[0].values,
            tickers = rankiaData.RANKIA_TICKERS,
            filteredResultsList = [],
            el = [],
            identifiersArray = (fund) ? tickers : isins;

        let checkVar, stats = {}, context = this;
        list.forEach(function (item) {
            if (!fund) {
                stats = context.getStatsData(item);
            }
            if (identifiersArray.length > 0) {
                for (let index = 0; index < identifiersArray.length; index++) {
                    checkVar = (fund) ? item.clientCode : item.properties_pub.isin.value;
                    if (identifiersArray[index] === checkVar) {
                        if (fund) {
                            el[identifiersArray[index]] = { "url": urlsRankia[index], "name": item.properties_pub.legal_name.value, "ticker": identifiersArray[index], "assetClass": item.properties_pub.asset_class.value };
                        }
                        else {
                            el[identifiersArray[index]] = { "isin": item.properties_pub.isin.value, "ticker": item.properties_pub.fund_key.value, "statistics": stats, "shareClassType": context.getShareClassName(item.properties_pub) };
                        }

                        filteredResultsList.push(el[identifiersArray[index]]);
                        identifiersArray.splice(index, 1);
                        urlsRankia.splice(index, 1); //Mutating arrays in place is terrible. DON'T EVER DO THIS!
                        break;
                    }
                }
            }

        });
        filteredResultsList = this.sortList(filteredResultsList, "ticker");
        if (benchIds) {
            return this.addBenchIds(filteredResultsList, benchIds);
        }
        return filteredResultsList;
    }

    sortList(list, prop) {
        let compare = function (a, b) {
            if (a[prop] < b[prop])
                return -1;
            if (a[prop] > b[prop])
                return 1;
            return 0;
        };
        return list.sort(compare);
    }

    getBenchMarkIdentifiers(res) {
        let benchMarkList = [];
        let i = 0;
        for (let prop in res) {
            benchMarkList[i] = {};
            benchMarkList[i]["fund_key"] = res[prop]["properties_pub"]["fund_key"]["value"];
            benchMarkList[i]["comparative_index"] = res[prop]["properties_pub"]["comparative_index"]["value"];
            benchMarkList[i]["comparative_index_sec_id"] = res[prop]["properties_pub"]["comparative_index_sec_id"]["value"];
            benchMarkList[i]["peer_group"] = res[prop]["properties_pub"]["peer_group"]["value"];
            benchMarkList[i]["peer_group_sec_id"] = res[prop]["properties_pub"]["peer_group_sec_id"]["value"];
            i++;
        }
        return this.sortList(benchMarkList, "fund_key");
    }

    addBenchIds(identsList, benchMarkList) {
        identsList.forEach(function (item, index) {
            if (item.ticker == benchMarkList[index]["fund_key"]) {
                delete benchMarkList[index]["fund_key"];
                identsList[index]["benchMarkObj"] = benchMarkList[index];
            }
        });
        return identsList;
    }

    getStatsData(item) {
        let data = {};
        item.statistics.forEach(function (item) {
            if (item.code == "morning_star_ytd_perf") {
                data = item;
                return;
            }
        });
        return data;
    }

    getBenchmarkSearchList(idn) {
        let searchValues = [], i = 0, data;
        for (let prop in idn) {
            data = idn[prop].benchMarkObj;
            if (data["comparative_index_sec_id"]) {
                searchValues[i] = data["comparative_index_sec_id"];
                i++;
            }
            if (data["peer_group_sec_id"]) {
                searchValues[i] = data["peer_group_sec_id"];
                i++;
            }
        }
        return [{ "property": "client_code", "values": searchValues, "matchtype": "MATCH" }];
    }

    buildBenchmarkList(res, searchList, idn) {
        let benchList = [], i = 0;
        searchList[0].values.forEach(function (item) {
            for (let p in res) {
                if (res[p].clientCode === item) {
                    if (res[p].properties_pub.is_benchmark.value) {
                        benchList[i] = { "code": item, "data": res[p]["statistics"].find(x => x.code === "mstar_ytd_benchmark_eur").values };
                        i++;
                    }
                    if (res[p].properties_pub.is_sector.value) {
                        benchList[i] = { "code": item, "data": res[p]["statistics"].find(x => x.code === "mstar_ytd_sector_eur").values };
                        i++;
                    }
                    if (res[p].properties_pub.is_ia_sector.value) {
                        benchList[i] = { "code": item, "data": res[p]["statistics"].find(x => x.code === "mstar_ytd_sector_eur").values };
                        i++;
                    }
                }
            }
        });
        idn.forEach(function (item) {
            benchList.forEach(function (bench) {
                if (item.benchMarkObj.comparative_index_sec_id === bench.code) {
                    item.benchMarkObj["stats"] = bench.data;
                }
                if (item.benchMarkObj.peer_group_sec_id === bench.code) {
                    item.benchMarkObj["sector_stats"] = bench.data;
                }
            });
        });
        return idn;
    }

    checkIdentifiersPresent(identList, secid) {
        for (let i = 0; i < identList.length; i++) {
            if (identList[i]["benchMarkObj"][secid] !== "0") {
                return true;
            }
        }
        return false;
    }

    getShareClassName(publicProperties) {
        let shareClassType = {};
        shareClassType["shareTypeAbbrev"] = publicProperties["share_type_abbreviation"]["value"];
        shareClassType["shareClassCurrencyCode"] = publicProperties["shareclass_currency_code"]["value"];
        shareClassType["shareClassCurrencyName"] = publicProperties["shareclass_currency_name"]["value"];
        shareClassType["shareClassLetter"] = publicProperties["shareclass_letter"]["value"];
        return shareClassType;
    }

    defineIdentifers(idFromJSON) {
        if (idFromJSON["fundnames"]) {
            rankiaData.RANKIA_FUND_SEARCH_PROPS[0]["values"] = idFromJSON["fundnames"];
        }
        if (idFromJSON["isins"]) {
            rankiaData.RANKIA_SHARECLASS_SEARCH_PROPS[0]["values"] = idFromJSON["isins"];
        }
        if (idFromJSON["tickers"]) {
            rankiaData.setValue(idFromJSON["tickers"], 'tickers');
        }
        if (idFromJSON["urls"]) {
            rankiaData.setValue(idFromJSON["urls"], 'urls');
        }
    }

    getRankiaData(productRange) {
        let trans = translations, ids = rankiaIdentifiers, rankiaidens = { 'isins': '', 'tickers': '', 'fundnames': '', 'productRange': '', 'assetClass': '', 'urls': '' };
        //WTF?
        if (trans[trans.length - 1].length === 1 && trans[trans.length - 1] === "") {
            trans.pop();
        }
        ids.forEach(function (item, index) {
            //Split on OEIC or SICAV or whatever productRange is requested
            if (item[5] == productRange) {
                rankiaidens["isins"] += item[0] + ',';
                rankiaidens["tickers"] += item[1] + ',';
                rankiaidens["fundnames"] += item[2] + ',';
                rankiaidens["productRange"] += item[5] + ',';
                rankiaidens["assetClass"] += item[6] + ',';
                rankiaidens["urls"] += item[11] + ',';
            }
        });
        rankiaidens = this.postProcessList(rankiaidens);
        return { "ids": rankiaidens, "translations": trans };
    }
    //TODO handle sector translations
    getTranslations(rankiaTranslations) {
        let translations = rankiaTranslations;
        let labelTranslations = {}, dataTranslations = {};
        for (let i = 0; i < translations.length; i++) {
            if (translations[i][1] === 'Label') {
                labelTranslations["translation" + i] = translations[i];
            }
            else if (translations[i][1] === 'Data') {
                dataTranslations["translation" + i] = translations[i];
            }
        }
        translations = { "label": labelTranslations, "data": dataTranslations };
        return translations;
    }

    postProcessList(rankiaObj) {
        rankiaObj.isins = this.formatIDs(rankiaObj.isins);
        rankiaObj.tickers = this.formatIDs(rankiaObj.tickers);
        rankiaObj.fundnames = this.formatIDs(rankiaObj.fundnames);
        rankiaObj.productRange = this.formatUnique(rankiaObj.productRange.split(','));
        rankiaObj.assetClass = this.formatUnique(rankiaObj.assetClass.split(','));
        rankiaObj.urls = this.formatIDs(rankiaObj.urls);
        return rankiaObj;
    }

    formatIDs(ids) {
        ids = ids.substring(0, ids.length - 1);
        ids = ids.split(',');
        return ids;
    }

    formatUnique(list) {
        list.splice(-1);
        return list.filter((value, index, self) => self.indexOf(value) === index);
    }

}



// WEBPACK FOOTER //
// ./src/client/containers/RankiaPerformanceContainer.tsx